import { type BrokersBrokerAttentionNeededItemReason } from 'utils/web_api.schemas'

export const ReasonCell = ({ value } : { value: BrokersBrokerAttentionNeededItemReason }) => {
  let label = ''
  switch (value) {
    case 'missing_payment':
      label = 'Missing payment'
      break
    case 'under_payment':
      label = 'Under payment'
      break
    case 'delinquency_risk':
      label = 'Delinquency risk'
      break
    case 'over_payment':
      label = 'Over payment'
      break
    case 'unexpected_amount':
      label = 'Unexpected amount'
      break
    case 'missing_enrollment':
      label = 'Missing enrollment'
      break
    case 'automation_reconciliation':
      label = 'Automation Reconciliation'
      break
    case 'incorrect_configuration':
      label = 'Incorrect configuration'
      break
    case 'payments_issue':
      label = 'Payments issue'
      break
    case 'backdate_requested':
      label = 'Backdate requested'
      break
    case 'offboarding':
      label = 'Offboarding'
      break
    case 'dependent_age':
      label = 'Dependent age'
      break
    case 'other':
      label = 'Other'
      break
    default:
      label = 'Unknown'
  }
  return <p>{label}</p>
}
